<rappider-list-grid [config]="endpointsGridConfig"
                    [data]="projectModelEndpoints"
                    [loading]="isLoading"
                    [className]="animateTable ? 'animated-table': ''"
                    [enableRowPointer]="enableRowPointer"
                    (listActionClick)="onListActionClick($event)"
                    (columnActionClick)="onColumnActionClick($event)"
                    (rowActionClick)="onRowActionClick($event)"></rappider-list-grid>
